<template>
  <div class="about">
    <h3>読んだ本を記録していこう！</h3>
    <div class="top-create">
      <form @submit.prevent="create">
        <b-form-group
          id="input-group-1"
          label="本のタイトル"
          label-for="input-1"
        >
          <b-form-input
            v-model="$v.title.$model"
            type="text"
            required
            placeholder="吾輩は猫である...etc"
          ></b-form-input>
          <div v-if="$v.title.$dirty">
            <div class="error" v-if="!$v.title.required">本のタイトルは必須入力です。</div>
          </div>
        </b-form-group>
        <b-form-group>
          <div>
            <b-form-select v-model="$v.type.$model" :options="options" class="mb-3">
              <template v-slot:first>
                <b-form-select-option :value="null" disabled>-- 本のタイプ --</b-form-select-option>
              </template>
            </b-form-select>
            <div v-if="$v.type.$dirty">
              <div class="error" v-if="!$v.type.required">本のタイプは必須入力です。</div>
            </div>
          </div>
        </b-form-group>
        <div>
          <b-form-rating v-model="$v.recommend.$model"></b-form-rating>
          <div v-if="$v.recommend.$dirty">
            <div class="error" v-if="!$v.recommend.required">オススメ度は必須入力です。</div>
          </div>
          <p class="mt-2">オススメ度: {{ recommend }}</p>
        </div>
        <div>
          <b-col sm="10">
            <b-form-textarea
              id="textarea-default"
              placeholder="読んでみての一言"
              v-model="$v.comment.$model"
            ></b-form-textarea>
            <!-- <div class="voice-box">
              <b-button @click="speechIn" pill variant="primary">{{startText}}</b-button>
              <b-button @click="speechOut" pill>停止</b-button>
            </div>
            <div v-if="$v.comment.$dirty">
              <div class="error" v-if="!$v.comment.required">コメントは必須入力です。</div>
              <div class="error" v-if="!$v.comment.maxLength">コメントは{{$v.comment.$params.maxLength.max}}文字以内です</div>
            </div> -->
          </b-col>
        </div>
        <b-button :disabled="$v.$invalid" type="submit" variant="primary">作成</b-button>
      </form>
    </div>
  </div>
</template>

<script>
// const recognition = new window.webkitSpeechRecognition();
// recognition.continuous = true;
// recognition.lang = 'ja';

import {required, maxLength} from 'vuelidate/lib/validators'
export default {
  data() {
    return {
      // startText: '音声入力開始',
      // record: recognition,
      title: '',
      type: null,
      options: [
        { value: '自己啓発、マインド系', text: '自己啓発、マインド系' },
        { value: '健康、睡眠、ワークアウト系', text: '健康、睡眠、ワークアウト系' },
        { value: 'ビジネス系、経済系', text: 'ビジネス系、経済系' },
        { value: 'プログラミング系', text: 'プログラミング系' },
        { value: '小説', text: '小説' },
        { value: 'エロ本', text: 'エロ本' },
      ],
      recommend: null,
      comment: null
    }
  },
  validations: {
    title: {
      required,
    },
    type: {
      required,
    },
    recommend: {
      required,
    },
    comment: {
      required,
      maxLength: maxLength(30)
    }
  },
  methods: {
    // speechIn() {
    //   this.record.start()
    //   this.startText = '音声入力中...'
    // },
    // speechOut() {
    //   this.record.stop()
    //   this.startText = "音声入力開始"
    // },
    create() {
      if(this.$v.$invalid) {
        console.log('error')
      } else {
        var post = {
          title: this.title,
          type: this.type,
          recommend: this.recommend,
          comment: this.comment,
          createdAt: new Date()
        }
        this.$store.dispatch('createPost', post)
      }
    }
  },
  // created() {
  //   this.record.onresult = (event) => {
  //     if(event.results.length > 0) {
  //       if(this.comment === null) {
  //         this.comment = event.results[0][0].transcript;
  //       } else {
  //         this.comment += event.results[0][0].transcript;
  //       }
  //     }
  //   }
  // }
}
</script>

<style scoped>
  .top-create{
    width: 50%;
    margin: auto;
  }
  .col-sm-10{
    margin-bottom: 10px;
    padding-right: 0;
    padding-left: 0; 
  }
  .error{
    background: mistyrose;
  }
  .voice-box{
    margin-top: 10px;
    margin-bottom: 30px;
    display: flex;
    justify-content: space-evenly;
  }
</style>
